
<fieldset class="dynamic-element">
  <row>
    <column></column>
    <suffix>
      <button class="btn-icon clear-to-red close" @click="deleteLimit">
        <icon class="times"></icon>
        <span class="sr-only">Delete</span>
      </button>
    </suffix>
  </row>
  <b-row>
    <b-column>
      <label :for="`title_${index}`" class="required">Enter Limit Name<required-indicator/></label>
      <input :id="`title_${index}`" v-model="limit.title" />
    </b-column>  
  </b-row>
  <b-row>
    <b-column>
      <label :for="`maximum_${index}`" class="required">Maximum<required-indicator/></label>
      <number-input :id="`maximum_${index}`" placeholder="Select Limit" v-model="limit.maximum"></number-input>
    </b-column>  
  </b-row>
  <div class="cta">
    <button
        class="btn grey"
        @click="addLimitRuleSet"
        v-if="limitRuleSets.length === 0"
    >+ Add Rule</button>
  </div>

  <template v-if="limitRuleSets.length > 0">
    <label>Conditional Rule Preview</label>
    <div class="em-block">
      <conditional-display-rule
        :key="limitRuleSets[0].client_id"
        :class="{ 'condition-rule': true }"
        :conditional-rule-set="limitRuleSets[0]"
        :totalRuleSets="1"
        :disabled="false"
        v-on:edit:conditional-rule-set="editConditionalRuleSet"
        v-on:remove:conditional-rule-set="removeConditionalRuleSet"
      ></conditional-display-rule>
    </div>
  </template>

  <label :for="`limit-not-reached-message-${index}`">Limit Not Reached Message</label>
  <wysiwyg
    v-model="limit.limit_not_reached_message"
    :id="`limit-not-reached-message-${index}`"
    v-bind="$attrs"
    :config-options="wysiwygConfigOptions"
    :name="`limit-not-reached-message-${index}`"
  ></wysiwyg>

  <label :for="`limit-reached-message-${index}`">Limit Reached Message</label>
  <wysiwyg
    v-model="limit.limit_reached_message"
    :id="`limit-reached-message-${index}`"
    v-bind="$attrs"
    :config-options="wysiwygConfigOptions"
    :name="`limit-reached-message-${index}`"
  ></wysiwyg>
</fieldset>
